module.exports = __webpack_public_path__ + "img/Sol.19719410.png";